import { Dispatch } from "@reduxjs/toolkit";
import { APIFieldType, FieldType, FieldTypeType } from "../helpers/types";
import { apiDelete, apiGet, apiPost, apiPut } from "./generic.api";
import { MAX_POSITION } from "../helpers/constants";
import { TFunction } from "i18next";

export const getFieldsForTab = async (
  t: TFunction,
  dispatch: Dispatch,
  tabID: number
): Promise<FieldType[]> => {
  const response = await apiGet<{ fields: FieldType[] }>(
    dispatch,
    `api/field?tabID=${tabID}`
  );

  const fields = response?.fields || [];

  fields.push({
    fieldID: `${tabID}-more-info`,
    name: t("moreInfo"),
    type: FieldTypeType.TextArea,
    noteOption: false,
    tabID: tabID,
    position: MAX_POSITION,
    placeholder: "",
    defaultValue: "",
    value: undefined,
  });

  return fields;
};

export const changeFieldsPositions = async (
  dispatch: Dispatch,
  fields: FieldType[]
): Promise<FieldType[]> => {
  return (
    (await apiPost<{ data: any }, FieldType[]>(dispatch, `api/field`, fields))
      ?.data || []
  );
};

export const deleteField = async (
  dispatch: Dispatch,
  fieldID: number
): Promise<FieldType[]> => {
  return (
    (
      await apiDelete<{ data: any }, number>(
        dispatch,
        `api/field?fieldID=${fieldID}`
      )
    )?.data || []
  );
};

export const createNewField = async (
  dispatch: Dispatch,
  data: APIFieldType
): Promise<FieldType[]> => {
  return (
    (await apiPut<{ updatedFields: FieldType[] }, { data: APIFieldType }>(
      dispatch,
      `api/field/create`,
      { data }
    )) || []
  ).updatedFields;
};

export const updateField = async (
  dispatch: Dispatch,
  data: APIFieldType
): Promise<FieldType[]> => {
  return (
    (await apiPost<{ updatedFields: FieldType[] }, { data: APIFieldType }>(
      dispatch,
      `api/field/edit`,
      { data }
    )) || []
  ).updatedFields;
};
